import { render, staticRenderFns } from "./MedicalLabelComponent.vue?vue&type=template&id=468d2160&scoped=true&"
import script from "./MedicalLabelComponent.vue?vue&type=script&lang=js&"
export * from "./MedicalLabelComponent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=468d2160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d2160",
  null
  
)

export default component.exports